<div class="coupon-code-input-wrapper" [class.flex-line]="!gotCoupon && showPaymentMethods">
  @if (!gotCoupon) {
  <div (click)="gotCoupon = true" class="coupon-code-input-switcher">
    <a class="link">Got coupon?</a>
  </div>
  @if(showPaymentMethods){
  <div class="payment-methods">
    <img src="./../../../../assets/images/footer/mastercard.svg" alt="payment-method">
    <img src="./../../../../assets/images/footer/visa.svg" alt="payment-method">
    <!--
                <img src="./../../../../assets/images/footer/pei.svg" alt="payment-method">
        -->
  </div>
  }
  }

  @if (gotCoupon) {
  <div class="coupon-code-input-form">
    <app-inline-input-control [classess]="'mb-unset no-label'" [lightMode]="true" [control]="couponCodeControl"
      [placeholder]="'Coupon code'" [name]="'coupon-code'"></app-inline-input-control>
    <button (click)="applyCouponCode()" class="c-button dark" pButton pRipple
      [disabled]="!couponCodeControl.value">Apply</button>
  </div>
  }
</div>
